import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Login } from './pages/Login';
import { Management } from './pages/Management';
import { Admin } from './pages/Admin';
import { Display } from './pages/Display';
import { Clients } from './pages/Clients';
import { Establishments } from './pages/Establishments';
import { Fonts } from './pages/Fonts';
import { Tariffs } from './pages/Tariffs';
import { Banners } from './pages/Banners';
import { Products } from './pages/Products';
import { Extras } from './pages/Extras';
import { Screens } from './pages/Screens';
import { Icons } from './pages/Icons';
import { Users } from './pages/Users';
import { Monitoring } from './pages/Monitoring';
import { SmartBanners } from './pages/SmartBanners';
import { Toaster } from './components/ui/sonner';
import './App.css';
import { DisplayScreen } from './pages/DisplayScreen';

function App() {
  console.log('App component rendering');
  
  return (
    <AuthProvider>
      <Toaster />
      <Routes>
        {/* Rutas públicas */}
        <Route path="/login" element={<Login />} />
        <Route path="/display/:token" element={<DisplayScreen />} />
        
        {/* Ruta por defecto: redirigir a login o según rol */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        
        {/* Rutas protegidas por rol */}
        <Route
          path="/management"
          element={
            <ProtectedRoute allowedRoles={['admin', 'management', 'client', 'establishment']}>
              <Management />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/management/clients"
          element={
            <ProtectedRoute allowedRoles={['admin', 'management']}>
              <Clients />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/management/establishments"
          element={
            <ProtectedRoute allowedRoles={['admin', 'management', 'client', 'establishment']}>
              <Establishments />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/management/fonts"
          element={
            <ProtectedRoute allowedRoles={['admin', 'management', 'client', 'establishment']}>
              <Fonts />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/management/tariffs"
          element={
            <ProtectedRoute allowedRoles={['admin', 'management', 'client', 'establishment']}>
              <Tariffs />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/management/banners"
          element={
            <ProtectedRoute allowedRoles={['admin', 'management', 'client', 'establishment']}>
              <Banners />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/management/smart-banners"
          element={
            <ProtectedRoute allowedRoles={['admin', 'management', 'client', 'establishment']}>
              <SmartBanners />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/management/products"
          element={
            <ProtectedRoute allowedRoles={['admin', 'management', 'client', 'establishment']}>
              <Products />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/management/extras"
          element={
            <ProtectedRoute allowedRoles={['admin', 'management', 'client', 'establishment']}>
              <Extras />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/management/screens"
          element={
            <ProtectedRoute allowedRoles={['admin', 'management', 'client', 'establishment']}>
              <Screens />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/management/icons"
          element={
            <ProtectedRoute allowedRoles={['admin', 'management', 'client', 'establishment']}>
              <Icons />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/management/monitoring"
          element={
            <ProtectedRoute allowedRoles={['management']}>
              <Monitoring />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute allowedRoles={['admin', 'management']}>
              <Users />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/admin"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <Admin />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/display"
          element={
            <ProtectedRoute allowedRoles={['establishment']}>
              <Display />
            </ProtectedRoute>
          }
        />
        
        {/* Ruta catch-all: redirigir a login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
